import { render, staticRenderFns } from "./ContactDistributionsByTag.vue?vue&type=template&id=f3ec452e&scoped=true"
import script from "./ContactDistributionsByTag.vue?vue&type=script&lang=js"
export * from "./ContactDistributionsByTag.vue?vue&type=script&lang=js"
import style0 from "./ContactDistributionsByTag.vue?vue&type=style&index=0&id=f3ec452e&prod&lang=scss"
import style1 from "./ContactDistributionsByTag.vue?vue&type=style&index=1&id=f3ec452e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ec452e",
  null
  
)

export default component.exports